if (!customElements.get('localization-modal')) {
  class LocalizationModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const countrySelect = document.getElementById('countryLabel');
      const languageSelect = document.getElementById('languageLabel');

      const stripLangFromPath = (path) => {
        return path.replace(/^\/[a-z]{2}(\/|$)/i, '/').replace(/\/[a-z]{2}\/?$/i, '/');
      };

      // On country change: strip language and update domain
      countrySelect.addEventListener('change', () => {
        const currentURL = new URL(window.location.href);
        const currentHostname = currentURL.hostname;
        const currentPort = currentURL.port ? `:${currentURL.port}` : '';
        let currentPath = stripLangFromPath(currentURL.pathname);

        const selectedCountry = countrySelect.value;
        let newDomain = currentHostname;

        if (selectedCountry === 'canada') {
          newDomain = 'ca.bluestarnutraceuticals.com';
        } else if (selectedCountry === 'usa') {
          newDomain = 'bluestarnutraceuticals.com';
        }

        const newURL = `https://${newDomain}${currentPort}${currentPath}`;
        window.location.href = newURL;
      });

      // On language change: preserve domain, insert language code after domain
      if (languageSelect) {
        languageSelect.addEventListener('change', () => {
          const currentURL = new URL(window.location.href);
          const currentPort = currentURL.port ? `:${currentURL.port}` : '';
          let currentPath = stripLangFromPath(currentURL.pathname);

          const selectedLanguage = languageSelect.value;
          if (selectedLanguage) {
            if (!currentPath.startsWith('/')) {
              currentPath = '/' + currentPath;
            }
            currentPath = `/${selectedLanguage}${currentPath}`;
          }

          const newURL = `${currentURL.protocol}//${currentURL.hostname}${currentPort}${currentPath}`;
          window.location.href = newURL;
        });
      }
    }
  }

  customElements.define('localization-modal', LocalizationModal);
}
